//TODO: change to correct values when app is uploaded on app store
export const appName = 'DBO Toko';
export const appStoreId = 1539139024;
export const appStoreLocale = 'id';
export const playStoreId = 'com.dbo.newdboindonesiahd';
